// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8ba4ef9b","404":"7b127a17","498":"b5dc8482","787":"e5345ab3"}[chunkId] + ".chunk.js";
};